export const getButtonStyle = (backgroundColor: string, borderColor: string) => ({
  display: 'flex',
  padding: '8px 20px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '8px',
  border: `1px solid ${borderColor}`,
  background: backgroundColor,
  boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.05)',
  '&:hover': { backgroundColor },
  width: 'max-content',
});
